import { SkipLinkConfig } from "./useSkipLinks";

type Listener = (links: SkipLinkConfig[]) => void;

class SkipLinkRegistry {
  private links = new Map<string, SkipLinkConfig>();
  private listeners = new Set<Listener>();

  register(config: SkipLinkConfig) {
    this.links.set(config.id, config);
    this.emitAsync();
  }

  unregister(id: string) {
    if (!this.links.has(id)) return;

    this.links.delete(id);
    this.emitAsync();
  }

  // remove all skip links
  clear() {
    if (this.links.size === 0) return;

    this.links.clear();
    this.emitAsync();
  }

  subscribe(listener: Listener) {
    this.listeners.add(listener);

    // The queueMicrotask makes sure that it unsubscribes before it runs - ensure subscribers get current registry state
    // delay link registration until the next micro task so the provider always subscribes first and is always listening. 
    // goal was to eliminate race conditions and timing issues
    queueMicrotask(() => {
      // guard in case it unsubscribed before the microtask runs
      if (!this.listeners.has(listener)) return;
      listener([...this.links.values()]);
    });

    return () => {
      this.listeners.delete(listener);
    };
  }

  private emitAsync() {
    const snapshot = [...this.links.values()]; // state at emission

    // fires after React finishes rendering
    queueMicrotask(() => {
      this.listeners.forEach((l) => l(snapshot));
    });
  }
}

export const skipLinkRegistry = new SkipLinkRegistry();